export const welcomeModal = {
  extend: 'ModalWindow',
  tag: 'form',
  ModalHeader: {
    props: ({ state }) => ({
      title: state.title,
      p: state.description
    })
  },
  Flex: {
    align: 'stretch flex-start',
    gap: 'C1',
    padding: 'Z2 -',
    Iframe: {
      props: (el, s) => ({
        boxSize: '315px 560px',
        src: s.youtube,
        // `title` on an iframe is the a11y NAME screen readers announce, so it
        // is an HTML attribute and takes the FUNCTION form
        // (docs/I18N-CONVENTION.md §1). `s.title` carries the KEY.
        title: el.call('polyglot', s.title),
        border: '0',
        round: 'X2',
        margin: '-B -Z -Z',
        minHeight: '0',
        allow:
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
        allowfullscreen: true
      })
    }
  },
  on: {
    init: (el, s) => {
      s.update(
        {
          // KEY-IN-STATE — the iframe's `title` resolves these through
          // `el.call('polyglot', …)` above. `ModalHeader` reads `title`/`p`
          // as CONTENT and renders NEITHER today (its `Hgroup.H` carries no
          // `text:`), so that path is inert either way — see the
          // `#modalHeader` entries in `__tests__/i18nSharedExtraction.test.js`.
          title: 'editor.welcomeModal.title',
          description: 'editor.welcomeModal.descr',
          youtube: 'https://www.youtube.com/embed/QIdimVDuSEU?si=NaGhGaHADN8jj_aH&amp;controls=0'
        },
        {
          preventUpdate: true
        }
      )
    }
  }
}
